import { Icon, IconSize } from "@blueprintjs/core"
import { useCurrentDepartmentAccess } from "graphql/auth/auth.hooks"
import DCSelector from "pages/DCSelector"
import ProductionDepotSelector from "pages/production/ProductionDepotSelector"
import React from "react"
import { Route, Routes, useLocation } from "react-router-dom"
import mainRoutes from "routes/main.routes"

const AppHeading = () => {
  const isEcom = useCurrentDepartmentAccess()
  const location = useLocation()
  console.log(location)

  return (
    <Routes>
      {mainRoutes?.map(mvr => {
        const IconComponent = mvr.icon
        return (
          <Route
            key={mvr.path}
            path={`${mvr.path}/*`}
            element={
              <>
                <span className="vt-module-heading">
                  {typeof IconComponent === "string" ? (
                    <Icon iconSize={IconSize.LARGE} icon={IconComponent} />
                  ) : (
                    <IconComponent
                      height={IconSize.LARGE}
                      width={IconSize.LARGE}
                    />
                  )}
                  <span className="vt-heading-text ml-2">{mvr.title}</span>
                </span>

                {/ecom|vehicle|fsm/.test(mvr.path) && isEcom ? (
                  <DCSelector />
                ) : null}

                {location.pathname === "/d/allocation" ? (
                  <ProductionDepotSelector />
                ) : null}
              </>
            }
          />
        )
      })}
    </Routes>
  )
}

export default AppHeading
